import { Modal, Spin } from "antd";
import VEHICLE from "../../assets/images/icons/outline-vehicle.png";

const vehicleIcon = <img src={VEHICLE} alt="#" className="vehicle-loader" />;
const Loader = ({ text, noText }) => {
  return noText ? (
    <Modal
      data-testid="loader"
      open={true}
      footer={null}
      closeIcon={false}
      className="text-center mt4 modal-loader"
      styles={{ mask: { backgroundColor: "#ffffff", opacity: 0.5 }}}
      width={80}
    >
      <Spin indicator={vehicleIcon} data-testid="spin" />
    </Modal>
  ) : (
    <Modal
      data-testid="loader"
      open={true}
      footer={null}
      closeIcon={false}
      className="text-center mt4 modal-loader"
      styles={{ mask: { backgroundColor: "#ffffff", opacity: 0.5 }}}
      width={220}
    >
      <Spin indicator={vehicleIcon} spinning={true} size="small" className="ml05" />
      <div className="ant-spin-text">{text ? text : "Loading"}</div>
    </Modal>
  );
};
export default Loader;
